import React from "react";
import { DataListProps } from "./DataList.types";
import { useStyles } from "./DataList.styles";
import DataItem from "./DataItem/DataItem";

function DataList<T>(props: DataListProps<T>) {
  const {
    data,
    idKey,
    ItemDetailsComponent,
    ItemMainComponent,
    selected,
    selectedDisabled,
    onToggleSelect,
    moreActions,
  } = props;

  const classes = useStyles();

  const isSelected = (item: T) => {
    return selected?.some((i) => i[idKey] === item[idKey]);
  };

  const isDisabled = (item: T) => {
    return selectedDisabled?.some((i) => i[idKey] === item[idKey]);
  };

  return (
    <ul className={classes.list}>
      {data.map((item) => (
        <DataItem<T>
          key={item[idKey] as unknown as string}
          item={item}
          ItemDetailsComponent={ItemDetailsComponent}
          ItemMainComponent={ItemMainComponent}
          selected={isSelected(item)}
          disabled={isDisabled(item)}
          idKey={idKey}
          onToggleSelect={onToggleSelect}
          moreActions={moreActions}
        />
      ))}
    </ul>
  );
}

export default DataList;
